import React from 'react'

const Social = () => {
  return (
    <div className="home__social">
        <a href="https://www.instagram.com/__woser_0_0/" className="home__social-icon" target='_blank'> 
        <i class="uil uil-instagram"></i>
        </a>

        <a href="https://dribbble.com/woser001" className="home__social-icon" target='_blank'> 
        <i class="uil uil-dribbble"></i>
        </a>

        <a href="https://github.com/PemaLama007" className="home__social-icon" target='_blank'> 
        <i class="uil uil-github-alt"></i>
        </a>

    </div>

    )
}

export default Social